import { render, staticRenderFns } from "./ReportWidgetView.vue?vue&type=template&id=5762ec1c&scoped=true"
import script from "./ReportWidgetView.vue?vue&type=script&lang=js"
export * from "./ReportWidgetView.vue?vue&type=script&lang=js"
import style0 from "./ReportWidgetView.vue?vue&type=style&index=0&id=5762ec1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5762ec1c",
  null
  
)

export default component.exports